module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.leadFiles), function(f, i) {
    return _c('div', {
      key: f.leadFile_id,
      staticClass: "row lined"
    }, [_c('div', {
      staticClass: "col"
    }, [_vm._v(_vm._s(f.file_name))]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(f.timestamp)) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_vm._v(_vm._s(f.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "col text-right"
    }, [_c('a', {
      staticClass: "btn btn-sm btn-download",
      attrs: {
        "href": f.leadFile_url + _vm.$store.getters.getToken
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download")]), _vm._v(" "), _c('dropdown-confirmation', {
      on: {
        "confirm": function($event) {
          _vm.deleteFile(f)
        }
      }
    })], 1)])
  }), _vm._v(" "), (!_vm.uploading && (!_vm.leadFiles || !_vm.leadFiles.length)) ? _c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("There are no files on this lead.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-form"
  }, [_c('vue-clip', {
    attrs: {
      "options": _vm.options,
      "on-added-file": _vm.fileAdded,
      "on-sending": _vm.sending,
      "on-complete": _vm.complete
    },
    scopedSlots: {
      "clip-uploader-body": function(props) {
        return _vm._l((props.files), function(file, i) {
          return _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (file.progress < 100 && file.status != 'success'),
              expression: "file.progress < 100 && file.status != 'success'"
            }],
            staticClass: "row lined upload-preview"
          }, [_c('div', {
            staticClass: "col"
          }, [_c('div', {
            staticClass: "media"
          }, [_c('div', {
            staticClass: "media-body"
          }, [(file.status == 'error') ? _c('a', {
            staticClass: "link-padding float-right",
            on: {
              "click": function($event) {
                props.files.splice(i, 1)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-remove text-danger"
          })]) : _vm._e(), _vm._v(" "), _c('h5', {
            staticClass: "mt-2"
          }, [_vm._v("\n                  " + _vm._s(file.name) + "\n                  "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (file.progress == 100 && file.status != 'added'),
              expression: "file.progress == 100 && file.status != 'added'"
            }],
            staticClass: "file-status",
            class: {
              'text-danger': _vm.isError(file.status), 'text-success': _vm.isSuccess(file.status)
            }
          }, [_vm._v(_vm._s(file.status))])]), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (file.progress < 100),
              expression: "file.progress < 100 "
            }],
            staticClass: "file-progress"
          }, [_c('span', {
            staticClass: "progress-indicator",
            class: {
              error: _vm.isError(file.status)
            },
            style: ({
              width: file.progress + '%'
            })
          })]), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (file.errorMessage),
              expression: "file.errorMessage"
            }],
            staticClass: "text-danger link-padding"
          }, [_vm._v(_vm._s(file.errorMessage))])])])])])
        })
      },
      "clip-uploader-action": function(props) {
        return [_c('button', {
          staticClass: "btn btn-primary dz-message",
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v("  Add File(s)")])]
      }
    }
  })], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Files")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row table-head"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("File Details")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("Date Added")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("Uploaded By")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55b8fc77!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/LeadFiles.vue
// module id = 389
// module chunks = 0